import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import withModal from 'components/modals/withModal';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { CONTACT_ERRORS } from 'constants/contact';
import {
  createBulkAccountBlacklistedContacts,
} from 'redux/actions/accountBlacklistedContactActions';
import ConfirmationModal from '../../modals/ConfirmationModal';
import { DEFAULT_CONTACT_QUERY_PARAMS } from '../../../containers/Accounts/AccountDetail/ContactsTab/index';
import { SELECT_ALL_SUCCESS } from '../../../constants/config';


class BlacklistBulkModal extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    selectedContacts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      contact_id: PropTypes.string,
    })).isRequired,
    account: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    getContacts: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    createBulkAccountBlacklistedContacts: PropTypes.func.isRequired,
    showNotification: PropTypes.func.isRequired,
    isSelectedAllContacts: PropTypes.bool.isRequired,
    countContacts: PropTypes.number.isRequired,
    removeSelection: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isOpen: false,
  };

  handleSubmit = async () => {
    const {
      account,
      getContacts,
      toggle,
      selectedContacts,
      showNotification,
      isSelectedAllContacts,
      preparedParams,
    } = this.props;

    toggle();

    // eslint-disable-next-line no-unused-expressions
    isSelectedAllContacts && showNotification(
      SELECT_ALL_SUCCESS,
      'success',
    );


    const objectsListToSave = selectedContacts
      .filter(seqContact => !seqContact.errors.some(err => err.error_type === CONTACT_ERRORS.BLACKLISTED))
      .map(obj => ({
        account: account.id,
        contact: obj.contact_id,
      }));
      // eslint-disable-next-line no-unused-expressions
    !isSelectedAllContacts && await this.props.createBulkAccountBlacklistedContacts(objectsListToSave);
    // eslint-disable-next-line no-unused-expressions
    isSelectedAllContacts && await this.props.createBulkAccountBlacklistedContacts(
      objectsListToSave,
      {
        ...preparedParams,
        ...DEFAULT_CONTACT_QUERY_PARAMS,
        ...{ all: true },
      },
    );
    // eslint-disable-next-line no-unused-expressions
    !isSelectedAllContacts &&
    showNotification(`${selectedContacts.length} contacts were marked as 'Do not contact'`, 'success');
    this.props.removeSelection();
    await getContacts({ ...preparedParams });
  }

  render() {
    const {
      toggle, isOpen, selectedContacts, isSelectedAllContacts, countContacts,
    } = this.props;
    return (
      <ConfirmationModal
        open={isOpen}
        onBackdropClick={toggle}
        title="Confirm"
        confirmLabel="Yes"
        onConfirmClick={this.handleSubmit}
        onCancelClick={toggle}
      >
        <React.Fragment>
          <span className="volt-modal--stressed">{isSelectedAllContacts ?
          countContacts : selectedContacts.length}  contacts
          </span>&nbsp;
            will be marked as <span className="volt-modal--red">DO NOT CONTACT</span> for this account
          <br />And will not be able to be used on any other campaigns or sequences belonging to account.
          <br /><br /> Do you wish to continue?
        </React.Fragment>
      </ConfirmationModal>
    );
  }
}

export default compose(connect(
  state => ({
    account: state.account,
  }),
  {
    createBulkAccountBlacklistedContacts,
  },
))(withModal(BlacklistBulkModal));
